import React from 'react';
import PropTypes from 'prop-types';
import ContactFormModal from '../../ContactSupportBanner/ContactFormModal';
import NoResultsImage from '../../../../assets/images/no-results-search.svg';
function NoSearchResults(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "no-results-container"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "no-results",
    src: NoResultsImage
  }), /*#__PURE__*/React.createElement("h3", null, "0 profiles matching your criteria."), /*#__PURE__*/React.createElement("p", null, "Clora can assist you with any need. Add a project and we will send you candidates."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: function onClick() {
      window.location.href = '/projects/add_project';
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  }), "Add Project"), /*#__PURE__*/React.createElement(ContactFormModal, props)));
}
NoSearchResults.propTypes = {
  csrfToken: PropTypes.string.isRequired
};
export default NoSearchResults;